import {
    Button,
    Checkbox,
    Collapse,
    Drawer,
    Dropdown,
    Input,
    Modal,
    Pagination,
    Popover,
    Tabs,
} from "antd";
import React, { useEffect, useState } from "react";
import MoreIcon from "../../images/more-horizontal.png";
import EditIcon from "../../images/edit.svg";
import DeleteIcon from "../../images/delete.svg";
import ViewIcon from "../../images/info.svg";
import { toast } from "react-toastify";
import moment from "moment";
import { useLocation } from "react-router-dom";
import axios from "../../helpers/axios";
import Moment from "moment";
import { DuplicateCheck, PreApporval_Employment_Type } from "../../helpers/constants";
const { Panel } = Collapse;


const citizenship = [
    {
        value: '1',
        label: 'Singaporean',
    },
    {
        value: '2',
        label: 'PR',
    },
    {
        value: '3',
        label: 'WP Holder',
    },
    {
        value: '4',
        label: 'Foreigner',
    },
];

const VehicleStatus = [
    {
        value: '0',
        label: 'No',
    },
    {
        value: '1',
        label: 'Yes (No intention to clear it off as i need that vehicle)',
    },
    {
        value: '2',
        label: 'Yes (Will clear off as Im selling that vehicle)',
    },
    {
        value: '3',
        label: 'Yes (But i will clear of that loan and keep that vehicle)',
    },
];

const PreApproval = () => {
    const accessToken = localStorage.getItem("agentModuleToken");
    const location = useLocation();
    const pagePermission = location.state;
    //console.log("PREAPPROVALPERMISSION", pagePermission);
    const [PreApprovalList, setPreApprovalList] = useState([]);
    const [totalData, setTotalData] = useState("");
    const [tempData, setTempData] = useState([]);
    const [PreApprovalCount, setPreApprovalCount] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [pagination, setPagincation] = useState({
        pageSize: 25,
        page: 1,
        apiCall: true
    });
    const [open, setOpen] = useState({
        open: false,
        data: {},
    });
    const [confirmationModel, setConfirmationModel] = useState({
        open: false,
        id: "",
        type: "",
    });

    const GetPreApprovalList = async (page, pageSize) => {
        if (pagination?.apiCall) {
            const resp = await axios.post(
                `/admin/pre-approval/list/${pageSize}/${page}`,
                {
                    keyword: searchText
                }
            );
            if (resp?.status < 400) {
                setPreApprovalCount(resp.data?.counts);
                setTotalData(resp?.data?.total);
                setPreApprovalList(resp.data.data);
                setTempData(PreApprovalList?.length > 0 ? DuplicateCheck(PreApprovalList?.concat(resp?.data.data)) : resp.data.data);
            }
        }
    };
    const GetPreApprovalListInfo = async (id) => {
        const resp = await axios.get(`/admin/pre-approval/info/${id}`);
        if (resp?.status < 400) {
            setOpen({
                open: true,
                data: resp.data.data,
            });
        }
    };

    const ResetValues = () => {
        GetPreApprovalList(1, 25);
        setConfirmationModel({
            open: false,
            id: "",
            type: "",
        });
    };

    const UpdateRoleStatus = async (id) => {
        const resp = await axios.delete(`admin/pre-approval/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (resp?.data?.resp_code < 400) {
            toast.success(resp?.data?.message);
            ResetValues();
        }
    };

    const handleMenuClick = (id) => {
        UpdateRoleStatus(id);
    };

    const handlePagination = (val) => {
        setPagincation({
            page: val,
            pageSize: 25,
            apiCall: true
        })
    }

    useEffect(() => {
        GetPreApprovalList(1, 25);

    }, [searchText]);


    useEffect(() => {
        GetPreApprovalList(pagination?.page, pagination?.pageSize);
    }, [pagination]);


    const GetLabelValues = (arr = [], id) => {
        const temp = arr.filter((it) => it?.value == id);
        if (temp?.length > 0) {
            return temp[0]?.label
        } else {
            return ""
        }
    }

    //console.log("OPENNN", totalData, PreApprovalList?.length, pagination);

    return (
        <div className="min-h-screen bg-[#F5F5F5]">
            <div className="pt-[20px] px-[26px] bg-white" style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <div className="flex items-center gap-[15px] justify-between">
                    <h1 className="text-[20px] font-[700]">Pre Approval</h1>
                </div>
                <div className="relative w-[250px] max-w-[100%] max-[700px]:w-[100%]">
                    <div className="absolute h-[100%] top-[0] left-[0] flex items-center max-[768px]:left-[10px] max-[768px]:top-[-2px]">
                        <img src="/images/search.svg" alt="search" className="pt-[3px]" />
                    </div>
                    <input
                        type="search"
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e.target.value)
                        }}
                        placeholder={"Search..."}
                        className="pl-[25px] outline-none text-[13px]  max-[768px]:border max-[768px]:border-gray-200 max-[768px]:p-[8px_20px_8px_33px] max-[768px]:rounded-[5px] max-[700px]:w-[calc(100%-20px)]"
                    />
                </div>
            </div>

            <div className="px-[26px] bg-white border-b border-[#f0f0f0]">
            </div>
            <div className="px-[26px] pt-[20px]">
                <div className="bg-white p-[10px] rounded-[10px]">
                    <div className="userAcctableBox">
                        <table>
                            <thead>
                                <tr>
                                    <th>Created Date</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Loan Amount</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {PreApprovalList?.length > 0 &&
                                    PreApprovalList?.map((item) => (
                                        <tr>
                                            <td>
                                                {moment(item?.created_at).format("DD MMMM YYYY")},{" "}
                                                {moment(item?.created_at).format("HH:mm")}
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item?.email}</td>
                                            <td>{item?.loanamount}</td>

                                            <td>
                                                {pagePermission?.delete_permission == 1 && (
                                                    <div
                                                        className="flex items-center gap-[10px] text-[#F80707] text-[13px] cursor-pointer"
                                                        onClick={() => {
                                                            setConfirmationModel({
                                                                open: true,
                                                                id: item?.id,
                                                                type: "delete",
                                                            });
                                                        }}
                                                    >
                                                        <img src={DeleteIcon} /> Delete
                                                    </div>
                                                )}
                                                <div
                                                    className="flex items-center gap-[10px] text-[13px] cursor-pointer"
                                                    onClick={() => {
                                                        GetPreApprovalListInfo(item?.id);
                                                    }}
                                                >
                                                    <img src={ViewIcon} /> View
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                {PreApprovalList?.length == 0 && (
                                    <tr>
                                        {" "}
                                        <td colspan="5" className="text-center">
                                            No records found
                                        </td>{" "}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination
                            count={pagination?.pageSize}
                            page={pagination?.page}
                            total={totalData}
                            onChange={handlePagination}
                            variant="outlined"
                            color="primary"
                        />
                    </div>
                </div>
            </div>
            <Modal
                title={
                    confirmationModel?.type === "unsub"
                        ? "Un Subscribe Application"
                        : "Delete Application"
                }
                centered
                open={confirmationModel?.open}
                onOk={() => {
                    handleMenuClick(confirmationModel?.id);
                }}
                onCancel={() =>
                    setConfirmationModel({
                        open: false,
                        id: "",
                        type: "",
                    })
                }
                wrapClassName="delApplModal"
                okText={<>Delete</>}
            >
                <p>Are you sure want to delete ?</p>
            </Modal>


            <Drawer
                title="Pre Approval Details"
                onClose={() =>
                    setOpen({
                        open: false,
                        data: {},
                    })
                }
                open={open?.open}
                size="large"
            >
                <div className="grid grid-cols-1 gap-x-3 gap-y-1 md:gap-y-4">
                    <div className="userInfo">
                        <div className="grid grid-cols-12 gap-x-3">
                            <div className="col-span-4">
                                <label>Created On:</label>
                                <p class="md:text-sm text-black ">
                                    {Moment(open.data.created_at).format("DD-MM-YYYYHH:MM")}
                                </p>
                            </div>
                            <div className="col-span-4">
                                <label>Updated On:</label>
                                <p class="md:text-sm text-black ">
                                    {Moment(open.data.updated_at).format("DD-MM-YYYY HH:MM")}
                                </p>
                            </div>
                        </div>

                    </div>{" "}
                    <div className="userInfo">
                        <div className="grid grid-cols-12 gap-x-3">
                            <div className="col-span-4">
                                <label>Name:</label>
                                <p class="md:text-sm text-black ">
                                    {open?.data?.name}
                                </p>
                            </div>
                            <div className="col-span-4">
                                <label>Email:</label>
                                <p class="md:text-sm text-black ">
                                    {open.data?.email}
                                </p>
                            </div>
                            <div className="col-span-4">
                                <label>Contact No:</label>
                                <p class="md:text-sm text-black ">
                                    {open?.data?.country_code}{open.data?.contact_no}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="userInfo">
                        <div className="grid grid-cols-12 gap-x-3">
                            <div className="col-span-4">
                                <label>Monthly Income:</label>
                                <p class="md:text-sm text-black ">
                                    ${open?.data?.monthly_income}
                                </p>
                            </div>
                            <div className="col-span-4">
                                <label>Employment Status:</label>
                                <p class="md:text-sm text-black ">
                                    {GetLabelValues(PreApporval_Employment_Type, open.data?.employment_type)}
                                </p>
                            </div>
                            {(open.data?.employment_type == 4 || open.data?.employment_type == 5) && (
                                <div className="col-span-4">
                                    <label>Estimated Savings:</label>
                                    <p class="md:text-sm text-black ">
                                        ${open.data?.estimated_savings}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="userInfo">
                        <div className="grid grid-cols-12 gap-x-3">
                            <div className="col-span-4">
                                <label>Citizenship Status:</label>
                                <p class="md:text-sm text-black ">
                                    {GetLabelValues(citizenship, open.data?.citizenship_status)}
                                </p>
                            </div>
                            <div className="col-span-4">
                                <label>Current Lawsuits:</label>
                                <p class="md:text-sm text-black ">
                                    {open.data?.lawsuit == 1 ? "Yes" : "No"}
                                </p>
                            </div>
                            <div className="col-span-4">
                                <label>Current Bankruptcy:</label>
                                <p class="md:text-sm text-black ">
                                    {open.data?.bankruptcy == 1 ? "Yes" : "No"}
                                </p>
                            </div>

                        </div>
                    </div>
                    <div className="userInfo">
                        <div className="grid grid-cols-12 gap-x-3">
                            <div className="col-span-4">
                                <label>Previous Bankrupt:</label>
                                <p class="md:text-sm text-black ">
                                    {open.data?.previous_bankrupt == 1 ? "Yes" : "No"}
                                </p>
                            </div>
                            {open.data?.previous_bankrupt == 1 && (
                                <div className="col-span-4">
                                    <label>Bankrupt Year:</label>
                                    <p class="md:text-sm text-black ">
                                        {open.data?.bankrupt_year}
                                    </p>
                                </div>
                            )}
                            <div className="col-span-4">
                                <label>Another Vehicle:</label>
                                <p class="md:text-sm text-black ">
                                    {open.data?.vehicle_status == 1 ? "Yes" : "No"}
                                </p>
                            </div>

                        </div>
                    </div>
                    {(Number(open.data?.progress) < 75 || open.data?.guarantor1_monthlyincome !== "") && (
                        <div className="userInfo">
                            <div className="grid grid-cols-12 gap-x-3">
                                <div className="col-span-4">
                                    <label>Guarantor1 Income:</label>
                                    <p class="md:text-sm text-black ">
                                        ${open.data?.guarantor1_monthlyincome}
                                    </p>
                                </div>
                                <div className="col-span-4">
                                    <label>Guarantor1 Employment Status:</label>
                                    <p class="md:text-sm text-black ">
                                        {GetLabelValues(PreApporval_Employment_Type, open.data?.guarantor1_employment_type)}
                                    </p>
                                </div>
                                {(open.data?.guarantor1_employment_type == 4 || open.data?.guarantor1_employment_type == 5) && (
                                    <div className="col-span-4">
                                        <label>Guarantor1 Estimated Savings:</label>
                                        <p class="md:text-sm text-black ">
                                            ${open.data?.guarantor1_estimated_savings}
                                        </p>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}
                    {Number(open.data?.progress) < 50 && (
                        <div className="userInfo">
                            <div className="grid grid-cols-12 gap-x-3">
                                <div className="col-span-4">
                                    <label>Guarantor2 Income:</label>
                                    <p class="md:text-sm text-black ">
                                        ${open.data?.guarantor2_monthlyincome}
                                    </p>
                                </div>
                                <div className="col-span-4">
                                    <label>Guarantor2 Employment Status:</label>
                                    <p class="md:text-sm text-black ">
                                        {GetLabelValues(PreApporval_Employment_Type, open.data?.guarantor2_employment_type)}
                                    </p>
                                </div>
                                {(open.data?.guarantor2_employment_type == 4 || open.data?.guarantor2_employment_type == 5) && (
                                    <div className="col-span-4">
                                        <label>Guarantor2 Estimated Savings:</label>
                                        <p class="md:text-sm text-black ">
                                            ${open.data?.guarantor2_estimated_savings}
                                        </p>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}

                </div>
            </Drawer>
        </div>
    );
};

export default PreApproval;
